import StripePermittedView from './StripePermittedView';

export default StripePermittedView;
